import classNames from 'classnames';

import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

import styles from './AssetImageContainer.module.css';

const AssetImageContainer: FCC<{ className?: string; rounded?: boolean; circle?: boolean }> = ({
  children,
  className = '',
  rounded = true,
  circle = false,
}) => (
  <div
    className={classNames(
      styles.container,
      'asset-image-container',
      className,
      {
        [styles.rounded]: rounded,
      },
      {
        [styles.circle]: circle,
      }
    )}>
    <>{children}</>
  </div>
);

export { AssetImageContainer };
